<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
    data() {
        return {

        };
    },
    components: {
    },
}
</script>

<style lang="scss">
*{
margin:0;padding:0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-size: 14px;
  height:100vh;
  -webkit-overflow-scrolling: touch;
}
input,
textarea {
  -webkit-appearance: none;
  /*去除input默认样式*/
}
ul,h1,h2,h3,h4,h5,h6{
  margin-block-start:0;
  margin-block-end:0;
}
.amap-logo {
  right: 0 !important;
  left: auto !important;
  display: none !important;
}

.amap-copyright {
  right: 70px !important;
  left: auto !important;
  opacity:0 !important;
}
</style>
